export { default as WalletConnectButton } from './WalletConnectButton';
